import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { addNewExpenses, getAllExpenses } from "../../../apis/expences";
import { Moment } from "moment";
import { formatDate } from "../../../environment";

const ExpensesList = () => {
  const initialValues = {
    name: "",
    rate: "",
    address: "",
    cash_bank: "",
    entryDate: ""
  };

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [total_Amt, setTotalAmt] = useState<number>(0);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { name, rate, address, cash_bank, entryDate } = formData;
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  type EmployeeResponse = {
    title: string;
    CurrentRole: string;
    amount: number;
    description: string;
    createdAt: string;
    id: any;
    Status: string;
    cash_bank: string;
    entryDate: string;
    key: number;
  };

  type EmployeeData = {
    key: number;
    Name: string;
    id: any;
    rate: number;
    address: string;
    createdAt: string;
    Status: string;
    cash_bank: string;
    entryDate: string;
  };
  const loginData = sessionStorage.getItem("info");
  const user_id = loginData ? JSON.parse(loginData).user_id : null;
  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id,
      };
      const response = await getAllExpenses(data);
      let employeeData = (response?.data?.expensesData || []).map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          Name: `${item.title}`,
          rate:
            item.amount !== undefined && item.amount !== null
              ? Number(item.amount)
              : 0,
          address: item.description || "--",
          createdAt: item.createdAt || "--",
          id: item.id,
          cash_bank: item.cash_bank,
          entryDate: item.entryDate,
        })
      );

      if (searchQuery) {
        const query = searchQuery.toLowerCase();
        employeeData = employeeData.filter((item: any) =>
          [item.Name, item.address, item.cash_bank, item.rate, item.entryDate].some(
            (value) => String(value ?? "").toLowerCase().includes(query)
          )
        );
      }
      const totalAmount = employeeData.reduce(
        (total: number, item: any) => total + (Number(item.rate) || 0),
        0
      );
      setTotalAmt(totalAmount);
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [searchQuery, state]);

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
    },
    {
      title: "Date",
      dataIndex: "entryDate",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{formatDate(text)}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.Name}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Description",
      dataIndex: "address",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{text}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Cash Or Bank",
      dataIndex: "cash_bank",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{text}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "rate",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.rate}</div>
            </p>
          </div>
        </div>
      ),
    },
  ];
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    let idData: any;
    if (loginData) {
      const response = JSON.parse(loginData);
      idData = response;
    }

    const payload = {
      status: "active",
      user_id: idData.user_id,
      user_type: idData.type,
      amount: formData.rate,
      title: formData.name,
      description: formData.address,
      cash_bank: formData.cash_bank,
      entryDate
    };
    try {
      const response = await addNewExpenses(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        setFormData(initialValues);
        fetchAllEmployees();
      }
    } catch (error) { }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add New Expense
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name\Mobile"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div style={{ margin: "0 1.5rem" }}>
                  <label style={{ color: "#000" }}>Total Amount</label>
                  <div
                    style={{
                      background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
                      color: "#fff",
                      borderRadius: "8px",
                      padding: "0.35rem 1rem",
                      marginTop: "5px",
                      fontWeight: 700,
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ₹ {Number(total_Amt || 0).toLocaleString("en-IN")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 3rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {allEmployeeData && allEmployeeData.length > 0 && (
                <Table
                  dataSource={allEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Expenses</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Entry Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            name="entryDate"
                            value={formData.entryDate}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Title <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="rate"
                            value={rate}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Description
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="textarea"
                            name="address"
                            value={address}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Payment Type</label>
                          <select
                            name="cash_bank"
                            className="form-control"
                            value={cash_bank}
                            onChange={handleChange}
                          >
                            <option value="">--select--</option>
                            <option value="cash">Cash</option>
                            <option value="bank">Bank</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Save{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default ExpensesList;
